export const SceneFormat = {
    'Splat': 0,
    'KSplat': 1,
    'Ply': 2,
    'Spz': 3
};
